import { components } from 'react-select';

export const CustomValueContainer = ({ children, ...props }) => {
    return (
        <components.ValueContainer {...props}>
            {children}
        </components.ValueContainer>
    );
};
